import EmojiPicker from 'emoji-picker-react';
import React, { useState, useRef } from 'react';
import { AudioIcon, CloseIcon, GifIcon, VideoIcon, PictureIcon, PlusIcon } from '../../assets/icons';
import ModalMenu from '../ModalMenu';
import { ReactComponent as GaleryIcon } from '../../img/ic_galeria.svg';
import ButtonIcon from '../../utils/components/ButtonIcon/ButtonIcon';

import ModalAudioPost from '../ModalAudioPost';
import ModalGif from '../ModalGif';
import emojiImg from "../../assets/img/smile.png";
import useModal from '../../utils/hooks/useModal';
import AudioPlayer from '../../components/AudioPlayer.jsx/AudioPlayer';
const ChatInput = ({ replyMenssage, setReplyMenssage, handleNewUserMessage, classNameContend = "container-input-chat-room " }) => {
    const [isSend, setIsSend] = useState(true)
    const [sendMessage, setSendMessage] = useState('')
    const [isShowAudio, setIsShowAudio] = useState(false)
    const [dataFiles, setDataFiles] = useState({})
    const [isShowGif, setIsShowGif] = useState(false)
    const [refStikerShow, isShowStiker, setIsShowStiker] = useModal(false)
    const [isOnlyMultimedia, setIsOnlyMultimedia] = useState(false)
    const [isOnlyAudio, setIsOnlyAudio] = useState(false)
    const [linkGifOrStiker, setlinkGifOrStiker] = useState('')
    const [isLinkGifOrStiker, setisLinkGifOrStiker] = useState(false)
    const [isOnlyGif, setIsOnlyGif] = useState(null);
    const [refOpt, isShowOpt, setIsShowOpt] = useModal(false)
    const fileRef = useRef(null);
    const selectAudio = (e) => {
        e.stopPropagation()
        setIsShowGif(false)
        setIsShowAudio(!isShowAudio)
    }
    const selectGif = (e) => {
        e.stopPropagation()
        setIsShowAudio(false)
        setIsShowGif(!isShowGif)
    }
    const selectStiker = (event) => {
        setIsShowStiker(true)
        //  setSendMessage(sendMessage + code.emoji)
    }
    const emojiChose = (event, code) => {
        //setIsShowStiker(true)
        setSendMessage(sendMessage + code.emoji)
    }
    const deleteFile = (idFile) => {
        setDataFiles(prevState => {
            delete prevState[idFile]
            return { ...prevState }
        })
    }

    const onFileChange = (event) => {
        var filesTarget = event.target.files
        var img = {}
        var video = {}
        setIsOnlyMultimedia(true)
        for (let i = 0; i < filesTarget.length; i++) {
            if (filesTarget[i].type.includes('image')) {
                img[i] = new Image()
                img[i].onload = (imgs) => {
                    filesTarget[i].url = URL.createObjectURL(filesTarget[i])
                    setDataFiles(prevState => { return { ...prevState, [filesTarget[i].url]: { type: filesTarget[i].type, taggedUsers: [], height: img[i].naturalHeight, width: img[i].naturalWidth, url: filesTarget[i].url, file: filesTarget[i] } } })
                }
                img[i].src = URL.createObjectURL(event.target.files[i])
            }
            if (filesTarget[i].type.includes('video')) {
                video[i] = document.createElement("video");
                video[i].onloadeddata = (imgs) => {
                    filesTarget[i].url = URL.createObjectURL(filesTarget[i])

                    setDataFiles(prevState => { return { ...prevState, [filesTarget[i].url]: { type: filesTarget[i].type, taggedUsers: [], height: video[i].videoHeight, width: video[i].videoWidth, url: filesTarget[i].url, file: filesTarget[i] } } })
                }
                video[i].src = URL.createObjectURL(event.target.files[i])
            }
            if (filesTarget[i].type.includes('audio')) {
                filesTarget[i].url = URL.createObjectURL(filesTarget[i])

                setDataFiles(prevState => { return { ...prevState, [filesTarget[i].url]: { type: filesTarget[i].type, taggedUsers: [], url: filesTarget[i].url, file: filesTarget[i] } } })
            }
        }
        console.log()
    }
    const clear = () => {
        setisLinkGifOrStiker(false)
        setlinkGifOrStiker('')
        setDataFiles({})
        setIsSend(true)
        setSendMessage('')
        if (setReplyMenssage) {
            setReplyMenssage(null)
        }

    }
    return (
        <div className={`${classNameContend} ${(Object.values(dataFiles).length > 0) && 'xcontainer-input-chat-room-img'}`}>
            <div className='relative'>
                {Object.values(dataFiles).length > 0 && <div className="content-multimedia-message-prev xscroll-menu">
                    {Object.values(dataFiles).map((data,index) => {
                        var viewData = <div></div>
                        if (data.type.includes('image'))
                            viewData =
                                <img alt="img" className='img-multimedia-message' src={data.url} />
                        if (data.type.includes('video'))
                            viewData =
                                <video preload="auto" className="video-post-view" controls>
                                    <source src={data.url}></source>
                                </video>
                        if (data.type.includes('audio'))
                            viewData =
                                <div className='parent-width row endContent' style={{height:"100px"}}>
                                     <AudioPlayer url={data.url}/>
                                    
                                </div>
                        return (
                            <div key={index} className="relative parent-width column centerContent centerItems" >
                                {viewData}
                                <div onClick={() => deleteFile(data.url)} className="close-modal-post">
                                    <CloseIcon className="cls-1" height="13" width="13" />
                                </div>
                            </div>
                        )
                    })
                    }
                </div>}
            </div>

            {replyMenssage && <div className="column parent-width ml-2 mb-1 relative">
                <div className="relative">
                    {'responder a:'} {replyMenssage.content.substr(0, 20) + `${replyMenssage.content.length > 20 ? '...' : ''}`}
                    <div onClick={() => setReplyMenssage(null)} className="delete-reply-msg">
                        <CloseIcon className="cls-1" height="8" width="8" />
                    </div>
                </div>
            </div>}
            <div className="column parent-width centerItems">
                <div className="search-bar-navbar input-chat-room">

                    <input
                        autoComplete="off"
                        className="input-inside-div-msg"
                        name="categorie"
                        type="text"
                        value={sendMessage}
                        placeholder=''
                        onKeyPress={e => {
                           
                            if (e.key === 'Enter' && !e.shiftKey) {
                                if ((sendMessage.length > 0 || Object.values(dataFiles).length > 0) && isSend) {
                                    e.preventDefault()
                                    handleNewUserMessage(dataFiles, sendMessage, clear)
                                    setIsSend(false)
                                }
                            }
                        }}
                        onChange={e => setSendMessage(e.target.value)}
                    />
                    <div className="items-message-icon" ref={node => {
                        refOpt.current = node
                        refStikerShow.current = node
                    }}>
                        <div className='emoji-picker-up emoji-picker-up-message' style={{
                            zIndex: 1200
                        }}>
                            {isShowStiker && <EmojiPicker onEmojiClick={emojiChose} />}
                        </div>

                        {/*      <div onClick={(e) => selectGif(e)} className="Gif-icon" >GIF</div> */}
                        {/*  <ModalMenu
                            contentButton={
                                <img src={emojiImg} alt="img" style={{ height: '20px', width: '20px', cursor: 'pointer', marginTop: '5px' }} />
                            }
                            contentModal={<div name="picker-emoji-new-post" className="emoji-picker-up emoji-picker-up-message">
                                <EmojiPicker onEmojiClick={myCallback} />
                            </div>}
                        />
                        <label>
                            <input disabled={isLinkGifOrStiker ? true : false} type="file" onChange={(event) => {

                                onFileChange(event)
                            }} multiple accept=".png,.jpg,.jpeg,.gif,video/*,audio/*" />
                            <div className="icon-new-media-message purple-icon-message mr-1 ml-1">
                                <GaleryIcon className=" white-svg" height="20" width="20" />
                            </div>
                        </label>
                        
                        <div className="">
                            <AudioIcon className='white-svg' height="20" onClick={(e) => {
                                if (!isLinkGifOrStiker)
                                    selectAudio(e)
                            }} />
                        </div> */}
                        <div onClick={() => {
                            setIsShowOpt(true)
                        }}>
                            <PlusIcon className='icon-options-message' height="20" />
                        </div>

                        <div>
                            <OptionsModal selectStiker={selectStiker} fileRef={fileRef} selectGif={selectGif} selectAudio={selectAudio} setIsShowOpt={setIsShowOpt} displayModal={isShowOpt} />
                            <input ref={fileRef} disabled={isLinkGifOrStiker ? true : false} type="file" onChange={(event) => {

                                onFileChange(event)
                            }} />
                        </div>


                    </div>
                </div>
               
            </div>

            <ModalAudioPost
                setOnlyAudio={setIsOnlyAudio}
                setData={setDataFiles}
                displayModal={isShowAudio}
                closeModal={selectAudio}
            />
            <ModalGif
                setOnlygif={setIsOnlyGif}
                setData={(data) => {
                    setDataFiles(data)
                    setlinkGifOrStiker(Object.values(data)[0].url)
                    setisLinkGifOrStiker(true)
                }}
                displayModal={isShowGif}
                closeModal={selectGif}
            />


        </div>
    )
};

export default ChatInput;

const OptionsModal = ({ fileRef, selectAudio, selectGif, displayModal, setIsShowOpt, selectStiker }) => {
    const divStyle = {
        display: displayModal ? 'block' : 'none'
    }
    return (
        <div style={divStyle}>
            <div className="content-options-message-container">
                <div className='content-options-message-icons'>
                    <div onClick={(e) => {
                        //if (!isLinkGifOrStiker)
                        selectAudio(e)
                    }}>
                        <AudioIcon className='icon-options-message' height="20" />
                    </div>
                    <div onClick={(e) => {
                        //if (!isLinkGifOrStiker)
                        //  selectAudio(e)
                        fileRef.current.accept = "video/*";
                        fileRef.current.click()
                    }}>
                        <VideoIcon className='icon-options-message' height="20" />
                    </div>
                    <div onClick={(e) => {
                        //if (!isLinkGifOrStiker)
                        //  selectAudio(e)
                        fileRef.current.accept = "image/*";
                        fileRef.current.click()
                    }}>
                        <PictureIcon className='icon-options-message' height="20" onClick={(e) => {
                            //if (!isLinkGifOrStiker)
                            //  selectAudio(e)
                        }} />
                    </div>
                    <div onClick={(e) => {
                        //if (!isLinkGifOrStiker)
                        //  selectAudio(e)
                        selectGif(e)
                    }}>
                        <GifIcon className='icon-options-message' height="20" onClick={(e) => {
                            // if (!isLinkGifOrStiker)
                            //      selectAudio(e)
                        }} />
                    </div>
                    <div onClick={(e) => {
                        //if (!isLinkGifOrStiker)
                        //  selectAudio(e)
                        selectStiker(e)
                    }}>
                        <img className='icon-options-message' height="20" src={emojiImg} />
                    </div>

                </div>


            </div>
        </div>
    )
}